/**
 * The art a My Pokémon RECORD is drawn with (2026-09-29 owner report: a
 * Gengar marked G-Max on its record page kept its plain art on the list).
 *
 * One rule for every surface: a picked form (regional, costume) wins, then
 * a G-Max copy draws its Gigantamax render, else the species art. The
 * Dynamax page had this rule to itself; the list rows and the record hero
 * only knew about forms.
 */
import { speciesFormArtCandidates } from "./formSpriteCandidates";
import { megaGmaxSpriteCandidates } from "./megaGmaxSprites";

export function recordArtCandidates(r: {
  speciesId: number | null;
  formId?: string | null;
  isShiny?: boolean;
  isGmax?: boolean;
}): string[] | undefined {
  if (r.speciesId == null) return undefined;
  const form = speciesFormArtCandidates(r.speciesId, r.formId ?? null, { shiny: !!r.isShiny });
  if (form && form.length > 0) return form;
  if (r.isGmax) {
    const gmax = megaGmaxSpriteCandidates("gmax", r.speciesId, { shiny: !!r.isShiny });
    if (gmax.length > 0) return gmax;
  }
  return undefined;
}
